/* Big Gun V2 TFI upsell: the tune hero on Power Box 101 and /pages/tuning.
   Loaded only by sections/bgv2-tune-hero.liquid. The server renders State E
   (the finder entry); this file swaps in, by precedence:
     A  Garage machine, a TFI fits every year       "Your Raptor 700 is fuel-injected..."
     B  Garage machine, TFI fits make+model, not the year
     C  Garage machine, no TFI fits
     D  no Garage, a pipe was viewed (sessionStorage bgv2_last_exhaust): match on
        the pipe's fit tag and years (full -> A layout, partial -> B wording)
   Data: #bgv2-tfi-data (snippets/bgv2-tfi-payload.liquid), copy:
   #bgv2-tune-strings (Theme settings > Big Gun V2 > TFI tune hero).
   Matching uses window.BGE.Garage.fits() with tags joined by '|', never
   commas. Every add writes the cart attribute tfi_src (pb101 | tuning). */
(function () {
  'use strict';

  var hero = document.querySelector('[data-bgv2-tune-hero]');
  if (!hero) return;

  function parse(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var S = parse('bgv2-tune-strings') || {};
  var ROWS = parse('bgv2-tfi-data') || [];
  var TFI = ROWS.filter(function (r) { return r.k === 'tfi'; });
  // Every in-stock box, TFI Power Box and Rev Box: the hero names the rider's box by the shared year rule whatever its
  // kind (FL2-22, call 24), so a 2002 Raptor 660 gets its Rev Box, never "no Power Box is listed". The in-hero finder
  // (fuel type questions) stays Power Box only.
  var BOXES = ROWS;
  function isRev(row) { return !!(row && row.k === 'rev'); }
  // The box's own words: "Rev Box" for a Rev Box in the Power Box copy (no new copy, call 57).
  function kt(text, row) { return isRev(row) ? String(text || '').replace(/Power Box/g, 'Rev Box') : text; }
  var CFG = window.BGV2 || {};
  var SURFACE = hero.getAttribute('data-surface') || 'pb101';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Fill {tokens}, escape the result, tidy spaces left by an empty token.
  function fill(tpl, t) {
    var out = String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return t && t[k] != null ? t[k] : ''; });
    return esc(out.replace(/\s{2,}/g, ' ').replace(/\s+([.,?])/g, '$1').trim());
  }
  function list(s) { return String(s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); }
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/g, parts.join('.')).replace(/<[^>]+>/g, '');
  }
  function yearRange(tag) {
    var m = String(tag || '').trim().match(/^(\d{2}|\d{4})-(\d{2}|\d{4})$/);
    if (!m) return null;
    var f = function (y) { y = parseInt(y, 10); return y >= 100 ? y : (y <= 30 ? 2000 + y : 1900 + y); };
    return [f(m[1]), f(m[2])];
  }
  function yearsText(tag) {
    var r = yearRange(tag);
    if (!r) return '';
    return r[0] === r[1] ? String(r[0]) : r[0] + ' to ' + r[1];
  }
  function overlap(a, b) {
    var ra = yearRange(a), rb = yearRange(b);
    if (!ra || !rb) return true;
    return ra[0] <= rb[1] && rb[0] <= ra[1];
  }
  function hasTag(row, tag) { return !!tag && ('|' + row.tags + '|').indexOf('|' + tag + '|') >= 0; }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* ignore */ }
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).catch(function () { throw new Error('Could not add. Try again.'); }).then(function (r) {
      // Shopify's own message when it sends one ("only 2 left"); a dropped connection or a non-JSON page (a 429)
      // gets the house line, never "Failed to fetch" or "Unexpected token '<'" (CR-07).
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok || !j) throw new Error((j && (j.description || j.message)) || 'Could not add. Try again.');
        return j;
      });
    });
  }
  function setCartAttr(key, value) {
    var a = {}; a[key] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: a })
    }).catch(function () { /* attribution is best effort */ });
  }
  function lastExhaust() {
    try { return JSON.parse(sessionStorage.getItem('bgv2_last_exhaust') || 'null'); } catch (e) { return null; }
  }
  function partName(type) {
    if (/full/i.test(type || '')) return 'full system';
    if (/slip/i.test(type || '')) return 'slip-on';
    if (/head/i.test(type || '')) return 'head pipe';
    return 'pipe';
  }
  var TWO_WORD_MAKES = ['Arctic Cat', 'Can Am', 'Can-Am', 'John Deere'];
  function modelFromMachine(machine) {
    var m = String(machine || '');
    for (var i = 0; i < TWO_WORD_MAKES.length; i++) {
      if (m.indexOf(TWO_WORD_MAKES[i] + ' ') === 0) return m.slice(TWO_WORD_MAKES[i].length + 1);
    }
    return m.indexOf(' ') > 0 ? m.slice(m.indexOf(' ') + 1) : m;
  }
  // A TFI tagged with a make but no model would "fit" every model of that make.
  function hasModel(row) {
    return !(window.BGE && window.BGE.parseTags) || window.BGE.parseTags(row.tags).models.length > 0;
  }
  var ICO = {
    tick: '<svg class="bgv2-ico" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M8.3 14.2 4.1 10l1.5-1.5 2.7 2.7 6-6L15.8 6.7z"/></svg>',
    warn: '<svg class="bgv2-ico is-warn" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 2 1 18h18L10 2zm-1 6h2v5H9V8zm0 6h2v2H9v-2z"/></svg>'
  };
  function tel() { return 'tel:' + String(S.phone || '').replace(/[^\d+]/g, ''); }

  // ---------------------------------------------------------------------------
  // Matching
  // The one box rule (BGV2Tfi.forYear in biggun-v2.js, calls 24 and 36): among the boxes whose readable years cover
  // the year, the narrowest wins, a tie keeps catalogue order. The tuner row, the FAQ card and the drawer use it.
  function forYear(rows, year) {
    var T = window.BGV2Tfi;
    if (T && typeof T.forYear === 'function') return T.forYear(rows, year);
    var y = parseInt(year, 10), best = null, span = Infinity;
    rows.forEach(function (r) { var rr = yearRange(r.y); if (rr && y >= rr[0] && y <= rr[1] && rr[1] - rr[0] < span) { best = r; span = rr[1] - rr[0]; } });
    return best;
  }
  function matchGarage(garage) {
    var v = garage && garage.active();
    if (!v) return null;
    var fitting = [], partial = null;
    BOXES.forEach(function (r) {
      if (!hasModel(r)) return;
      var st = garage.fits(r.tags);
      if (st === 'fits') fitting.push(r);
      else if (st === 'wrong_year' && !partial) partial = r;
    });
    // Every box that fits this machine, then the shared rule picks the one for its year: the first fitting box gave
    // a 2021 RZR XP 1000 the 15-23 box over the 18-22 one (FL1-19). A box whose years cannot be read stands only
    // when it is the only one; several such boxes are never guessed between (call us).
    // A sold-out box made for this year is in the same rule (FL1-35, call 31): when it wins the year, or no in-stock box
    // covers the year, the hero says it is sold out (state C) instead of offering another years' box as a partial.
    var sold = soldRows(v);
    if (sold.length) {
      var win = forYear(fitting.concat(sold.map(function (r) { return { y: r.y, k: r.k, __sold: true }; })), v.year);
      // The sold-out box's kind carries to the call-31 line ("The Rev Box for your ... is sold out", FL3-01).
      if (!win || win.__sold) return { v: v, row: null, state: 'C', soldK: win && win.__sold ? win.k : '' };
    }
    var full = fitting.length ? forYear(fitting, v.year) : null;
    if (!full && fitting.length === 1 && !yearRange(fitting[0].y)) full = fitting[0];
    if (!full && fitting.length) return { v: v, row: null, state: 'C' };
    return { v: v, row: full || partial, state: full ? 'A' : (partial ? 'B' : 'C') };
  }
  function matchPipe(pipe) {
    if (!pipe || !pipe.fit) return null;
    var rows = BOXES.filter(function (r) { return hasTag(r, pipe.fit) && overlap(pipe.y, r.y); });
    if (!rows.length) return null;
    var pr = yearRange(pipe.y), covered = true;
    if (pr) {
      for (var y = pr[0]; y <= pr[1]; y++) {
        var hit = rows.some(function (r) { var rr = yearRange(r.y); return !rr || (y >= rr[0] && y <= rr[1]); });
        if (!hit) { covered = false; break; }
      }
    }
    // No machine to give a year: the boxes that win the pipe's years under the shared rule, in year order. More than
    // one means the page cannot know which is the rider's, so it lists them by year with no one-tap add (FL1-19).
    var T = window.BGV2Tfi, wins = (T && typeof T.wins === 'function') ? (pr ? T.wins(rows, pr[0], pr[1]) : T.wins(rows)) : [];
    return { row: (wins[0] && wins[0].row) || rows[0], rows: rows, full: covered, wins: wins, multi: wins.length > 1 };
  }
  function pairFor(row, pipe) {
    if (!row || !pipe || !pipe.v || !hasTag(row, pipe.fit) || !overlap(pipe.y, row.y)) return null;
    return { pipe: pipe, total: (parseInt(pipe.p, 10) || 0) + row.p };
  }

  // ---------------------------------------------------------------------------
  // Rendering
  var head = qs('[data-hero-head]', hero), body = qs('[data-hero-body]', hero), card = qs('[data-hero-card]', hero);
  var live = qs('[data-hero-live]', hero);
  var jumpHtml = (function () { var j = qs('.bgv2-tune-hero__jump', hero); return j ? j.outerHTML : ''; })();
  // The server render (State E), restored when the Garage is cleared.
  var E_HTML = { head: head.innerHTML, body: body.innerHTML, card: card.innerHTML };
  function resetE() {
    head.innerHTML = E_HTML.head; body.innerHTML = E_HTML.body; card.innerHTML = E_HTML.card;
    card.classList.remove('bgv2-tfi--quiet');
    hero.setAttribute('data-state', 'E');
    var hh = qs('#bgv2-tune-h', hero);
    if (live && hh) live.textContent = hh.textContent;
  }

  function whyList(s) {
    var items = list(s);
    if (!items.length) return '';
    return '<ul class="bgv2-tune-hero__why">' + items.map(function (w) { return '<li>' + ICO.tick + '<span>' + esc(w) + '</span></li>'; }).join('') + '</ul>';
  }
  // A box title's trailing year range kept on one line ("(07-09)" never splits at 390, FL3-07), escaped first.
  function nwT(t) { return esc(t).replace(/ \(([^()]{1,11})\)$/, ' <span class="bgv2-nw">($1)</span>'); } // short tail only, FL3-12
  function itemHtml(row, machineName) {
    var img = row.img ? '<img class="bgv2-tfi__img" src="' + esc(row.img) + '" width="72" height="72" alt="' + esc((isRev(row) ? 'Rev Box' : 'TFI Power Box') + ' for the ' + machineName) + '" loading="lazy">' : '';
    return '<div class="bgv2-tfi__item">' + img + '<div class="bgv2-tfi__body">' +
      '<a class="bgv2-tfi__title" href="/products/' + esc(row.h) + '">' + nwT(row.t) + '</a>' +
      '<span class="bgv2-tfi__meta">' + (row.pn ? 'Part # ' + esc(row.pn) + '<span class="bgv2-dot" aria-hidden="true"></span>' : '') + esc(isRev(row) ? (S.warrantyRev || S.warranty) : S.warranty) + '</span>' +
      '<span class="bgv2-tfi__price bgv2-num">' + esc(money(row.p)) + '</span></div></div>';
  }
  // The closed-course line is the Power Box's (as on the PDP tuner row): a Rev Box card goes without it.
  function fine(row) { return S.ca && !isRev(row) ? '<p class="bgv2-tfi__fine">' + esc(S.ca) + '</p>' : ''; }
  // A Rev Box answer: the PDP's Rev heading and line, no Power Box warranty reasons.
  function boxH(tpl, t, row) { return isRev(row) ? fill(S.revH || 'Raise the rev limit', t) : fill(tpl, t); }
  // "How the Power Box works" jumps to the Power Box explainer: a Rev Box answer goes without it (FL3-03).
  function jumpFor(row) { return isRev(row) ? '' : jumpHtml; }
  function boxBody(t, row) { return isRev(row) ? '<p class="bgv2-tune-hero__line">' + fill(S.revLine, t) + '</p>' : '<p class="bgv2-tune-hero__line">' + fill(S.aLine, t) + '</p>' + whyList(S.aWhy); }
  function machineLine(icon, text, linkLabel, linkAttr) {
    return '<p class="bgv2-tune-hero__machine">' + (icon || '') + '<span>' + text + '</span>' +
      (linkLabel ? ' <button type="button" class="bgv2-textlink" ' + linkAttr + '>' + esc(linkLabel) + '</button>' : '') + '</p>';
  }
  function h2(text) { return '<h2 class="bgv2-tune-hero__h" id="bgv2-tune-h">' + text + '</h2>'; }

  // Full match card (A, and D with a full pipe match). Primary = the page's one accent.
  function fullCard(row, fitLine, machineName, pair) {
    var facts = isRev(row) ? [] : list(S.facts);
    return '<p class="bgv2-tfi__eyebrow">' + ICO.tick + '<span>' + fitLine + '</span></p>' +
      itemHtml(row, machineName) +
      (facts.length ? '<ul class="bgv2-tfi__facts">' + facts.map(function (f) { return '<li>' + ICO.tick + esc(f) + '</li>'; }).join('') + '</ul>' : '') +
      (pair ? '<div class="bgv2-tfi__pair"><span>' + fill(S.pair, { series: pair.pipe.series, part: partName(pair.pipe.type) }) + '</span><strong class="bgv2-num">' + esc(money(pair.total)) + '</strong></div>' : '') +
      '<div class="bgv2-tfi__actions">' +
        '<button type="button" class="bgv2-btn bgv2-btn--primary bgv2-btn--block" data-hero-add="tfi" data-k="' + esc(row.k || 'tfi') + '" data-variant="' + row.v + '" data-pn="' + esc(row.pn) + '">' + fill(kt(S.add, row), { price: money(row.p) }) + '</button>' +
        (pair ? '<button type="button" class="bgv2-textlink" data-hero-add="pair" data-k="' + esc(row.k || 'tfi') + '" data-variant="' + row.v + '" data-pipe="' + esc(pair.pipe.v) + '" data-pn="' + esc(row.pn) + '">' + fill(S.addPair, { total: money(pair.total) }) + '</button>' : '') +
      '</div>' + fine(row);
  }
  // Partial card (B, and D with a partial pipe match): quiet rule, no accent.
  // years: the amber warning only for a saved machine outside the box's years (state B, a real mismatch); with no
  // machine (the last-viewed pipe, state D) the shared years read neutral, no icon (call 82, FL3-13).
  function partialCard(row, years, machineName, neutral) {
    return '<p class="bgv2-tfi__eyebrow ' + (neutral ? 'is-years' : 'is-partial') + '">' + (neutral ? '' : ICO.warn) + '<span>' + fill(S.fitsPartial, { years: years }) + '</span></p>' +
      itemHtml(row, machineName) +
      '<div class="bgv2-tfi__actions"><button type="button" class="bgv2-btn bgv2-btn--secondary bgv2-btn--block" data-hero-add="tfi" data-k="' + esc(row.k || 'tfi') + '" data-variant="' + row.v + '" data-pn="' + esc(row.pn) + '">' + fill(/^\d{4}$/.test(String(years)) ? S.bAdd : (S.bAddRange || 'Mine is a {years} model. Add it'), { years: years }) + '</button></div>' +
      fine(row);
  }

  var current = 'E';
  var finderOn = false;
  function render(garage) {
    if (finderOn) return;
    var g = matchGarage(garage);
    var pipe = lastExhaust();
    var html = null, state = 'E', quiet = false, pn = '';
    if (g) {
      var v = g.v;
      var machine = window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : [v.year, v.make, v.model].join(' ');
      var t = { machine: machine, model: v.model || v.make, year: v.year, phone: S.phone };
      var change = 'data-bgv2-open-garage';
      state = g.state;
      if (g.state === 'A') {
        t.years = yearsText(g.row.y);
        html = {
          head: machineLine(ICO.tick, fill(S.machine, t), S.change, change) + h2(boxH(S.aH, t, g.row)),
          body: boxBody(t, g.row) + jumpFor(g.row),
          card: fullCard(g.row, fill(S.fits, t), machine, pairFor(g.row, pipe))
        };
      } else if (g.state === 'B') {
        t.years = yearsText(g.row.y);
        quiet = true;
        html = {
          head: machineLine(ICO.warn, fill(S.machine, t), S.change, change) + h2(boxH(S.bH, t, g.row)),
          body: '<p class="bgv2-tune-hero__line">' + fill(S.bLine, t) + '</p><p class="bgv2-tune-hero__jump"><a class="bgv2-textlink" href="' + tel() + '">' + fill(S.call, t) + '</a></p>',
          card: partialCard(g.row, t.years, machine)
        };
      } else {
        quiet = true;
        // The carbureted re-jet line only while bgv2_carb_hedge is on: most machines with no
        // box listed are fuel-injected, and the line read as a claim about theirs. Off, one
        // plain line replaces both the heading and the re-jet line.
        var noneLine = soldOut(v) ? kt(S.soldLine || 'The Power Box for your {model} is sold out right now. Call us about tuning.', { k: g.soldK || (soldRows(v)[0] || {}).k })
          : (S.noneLine || 'No Power Box is listed for your {model} yet. Call us about tuning.');
        html = {
          head: machineLine('', fill(S.machine, t), S.change, change) + h2(fill(S.carbHedge ? S.cH : noneLine, t)),
          body: S.carbHedge ? '<p class="bgv2-tune-hero__line">' + fill(S.cLine, t) + '</p>' : '',
          card: '<p class="bgv2-tfi__h">' + esc(S.cCard) + '</p><p class="bgv2-tfi__line">' + esc(S.hours) + '</p>' +
            '<div class="bgv2-tfi__actions"><a class="bgv2-btn bgv2-btn--primary bgv2-btn--block" href="' + tel() + '">' + fill(S.call, t) + '</a>' +
            '<a class="bgv2-textlink" href="#" data-hero-shop>' + fill(S.shop, t) + '</a></div>'
        };
      }
      if (g.row) pn = g.row.pn;
    } else if (pipe) {
      var pm = matchPipe(pipe);
      if (pm) {
        var model = modelFromMachine(pipe.machine);
        var pt = { model: model, series: pipe.series, part: partName(pipe.type), phone: S.phone, year: '' };
        var save = 'data-bgv2-open-garage';
        state = 'D';
        pn = pm.row.pn;
        // Every box on offer a Rev Box: the Rev heading and line, no Power Box fine print (FL2-22).
        var allRev = pm.wins.length ? pm.wins.every(function (w) { return isRev(w.row); }) : isRev(pm.row);
        if (pm.multi) {
          // Several boxes by year and no machine year: each box under its years, as links, no add.
          quiet = true;
          html = {
            head: machineLine('', fill(S.dMachine, pt), S.save, save) + h2(fill(S.dH, pt)),
            body: boxBody(pt, allRev ? pm.row : null) + jumpFor(allRev ? pm.row : null),
            card: pm.wins.map(function (w) { return '<p class="bgv2-tfi__eyebrow"><span>' + esc(((CFG.strings || {}).tunerFor || 'For {years}').replace('{years}', w.label)) + '</span></p>' + itemHtml(w.row, pipe.machine); }).join('') + fine(allRev ? pm.row : null)
          };
        } else if (pm.full) {
          html = {
            head: machineLine('', fill(S.dMachine, pt), S.save, save) + h2(fill(S.dH, pt)),
            body: boxBody(pt, pm.row) + jumpFor(pm.row),
            card: fullCard(pm.row, fill(S.fits, pt), pipe.machine, pairFor(pm.row, pipe))
          };
        } else {
          pt.years = pm.rows.map(function (r) { return yearsText(r.y); }).filter(Boolean).join(' and ');
          quiet = true;
          html = {
            // No machine (state D): no warning icon on the machine line either (call 82).
            head: machineLine('', fill(S.dMachine, pt), S.save, save) + h2(boxH(S.bH, pt, pm.row)),
            body: '<p class="bgv2-tune-hero__line">' + fill(S.bLinePipe, pt) + '</p><p class="bgv2-tune-hero__jump"><a class="bgv2-textlink" href="' + tel() + '">' + fill(S.call, pt) + '</a></p>',
            // Call 76 (FL2-06): the eyebrow and the "Mine is a ..." add name the years the box shares with the pipe
            // (the one winner's label); "Built for" above keeps the box's own years.
            card: partialCard(pm.row, (pm.wins.length === 1 && pm.wins[0].label) || pt.years, pipe.machine, true)
          };
        }
      }
    }
    if (!html) {
      if (current !== 'E') resetE();
      current = 'E';
      pickLine(garage);
      return;
    }
    head.innerHTML = html.head;
    body.innerHTML = html.body;
    card.innerHTML = html.card;
    card.classList.toggle('bgv2-tfi--quiet', quiet);
    hero.setAttribute('data-state', state);
    if (current !== 'E' || hero.getAttribute('data-hero-booted')) {
      var hh = qs('#bgv2-tune-h', hero);
      if (live && hh) live.textContent = hh.textContent;
    }
    current = state;
    pickLine(garage);
    resolveShop(g && g.v);
    track('view_promotion', { promotion_id: 'tfi_' + SURFACE, creative_slot: { A: 'full', B: 'partial', C: 'none', D: quiet ? 'partial' : 'full' }[state], items: pn ? [{ item_id: pn }] : [] });
  }

  // State C, but a box for this machine and year exists and is sold out: say so (bg-states
  // P3, the 2018 Wildcat Trail). #bgv2-tfi-soldout lists the unavailable boxes only:
  // [{ fit, y, t }] (cr47-server); none on the page means no sold-out line.
  var SOLD = null;
  function soldOut(v) { return soldRows(v).length > 0; }
  // The sold-out boxes made for this machine and its year (#bgv2-tfi-soldout).
  function soldRows(v) {
    if (SOLD === null) {
      try { var sj = document.getElementById('bgv2-tfi-soldout'); SOLD = sj ? (JSON.parse(sj.textContent || '[]') || []) : []; } catch (e) { SOLD = []; }
    }
    if (!v || !v.model || !SOLD.length) return [];
    var B = window.BGE || {};
    var hz = function (x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
    var fit = 'fit_' + hz(v.make) + '-' + hz(v.model), y = parseInt(v.year, 10);
    return SOLD.filter(function (r) {
      // Same match as the available boxes (#bgv2-tfi-data): the Garage's own fitment on the tags.
      if (r.tags && B.checkFitment && B.parseTags) return B.checkFitment(B.parseTags(r.tags), v) === 'fits';
      if (String(r.fit || '').toLowerCase() !== fit) return false;
      var rr = yearRange(r.y);
      return !rr || (y >= rr[0] && y <= rr[1]);
    });
  }

  // A machine saved before a model was required matches no box, so the hero never
  // says "we do not make one" for it (matchGarage sees no active machine). One line
  // at the top asks for the model; the pick opens the Garage drawer on that machine.
  function pickLine(garage) {
    var B = window.BGE || {};
    var raw = garage && garage.activeRaw ? garage.activeRaw() : null;
    var old = raw && !String(raw.model || '').trim() ? raw :
      (garage && garage.list && !garage.list().length && garage.needsModel ? garage.needsModel()[0] : null);
    var el = qs('[data-hero-pick]', head);
    if (!old || !B.pickModelHtml) { if (el) el.remove(); return; }
    var name = B.formatVehicle ? B.formatVehicle(old) : old.year + ' ' + old.make;
    var inner = '<span>Your ' + esc(name) + ' needs a model to match a Power Box.</span> ' + B.pickModelHtml(old, 'bgv2-textlink', 'Pick model');
    if (!el) {
      el = document.createElement('p');
      el.className = 'bgv2-tune-hero__machine bgv2-tune-hero__pick';
      el.setAttribute('data-hero-pick', '');
      head.insertBefore(el, head.firstChild);
    }
    if (el.__h !== inner) { el.innerHTML = inner; el.__h = inner; }
  }

  // C: "Shop exhaust for your [model]" goes to the model collection when one exists.
  function resolveShop(v) {
    var a = qs('[data-hero-shop]', hero);
    if (!a || !v) return;
    var fallback = window.BGE && typeof window.BGE.browseUrl === 'function' ? window.BGE.browseUrl(v) : '/collections/all';
    a.setAttribute('href', fallback);
    if (!CFG.modelCollectionsUrl) return;
    fetch(CFG.modelCollectionsUrl).then(function (r) { return r.json(); }).then(function (j) {
      var h = String(v.make + ' ' + v.model).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '-exhaust';
      if (j && (j.handles || []).indexOf(h) >= 0) a.setAttribute('href', '/collections/' + h);
    }).catch(function () { /* keep the fallback */ });
  }

  // ---------------------------------------------------------------------------
  // Adds: TFI alone (most readers own a pipe) or pipe + TFI. tfi_src after the add.
  hero.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hero-add]');
    if (!b) return;
    var items = [{ id: b.getAttribute('data-variant'), quantity: 1 }];
    if (b.getAttribute('data-hero-add') === 'pair' && b.getAttribute('data-pipe')) items.unshift({ id: b.getAttribute('data-pipe'), quantity: 1 });
    var pnv = b.getAttribute('data-pn') || '';
    var src = b.getAttribute('data-src') || SURFACE;
    b.setAttribute('aria-busy', 'true');
    b.disabled = true;
    track('select_promotion', { promotion_id: 'tfi_' + src, creative_slot: current, items: [{ item_id: pnv }] });
    addItems(items).then(function () {
      track('add_to_cart', { item_list_id: 'tfi_' + src, items: [{ item_id: pnv, quantity: 1 }] });
      // A Rev Box is not a Power Box sale: no tfi_src (FL1-02, FL2-22).
      return b.getAttribute('data-k') === 'rev' ? null : setCartAttr('tfi_src', src);
    }).then(function () {
      var a = document.createElement('a');
      a.href = '/cart';
      a.className = b.className.replace('bgv2-btn--primary', 'bgv2-btn--secondary') + ' is-done';
      if (b.classList.contains('bgv2-textlink')) a.className = 'bgv2-textlink';
      a.textContent = S.added || 'Added. View cart';
      var sib = b.parentNode.querySelector('[data-hero-add]:not([data-hero-add="' + b.getAttribute('data-hero-add') + '"])');
      if (sib) sib.remove();
      b.parentNode.replaceChild(a, b);
      a.focus();
    }).catch(function (err) {
      b.removeAttribute('aria-busy');
      b.disabled = false;
      b.textContent = err.message || 'Could not add';
    });
  });

  // ---------------------------------------------------------------------------
  // The finder (spec section 2): inline in the hero card, no modal.
  //   1 Machine (Year, Make, Model from the Garage vocabulary; saved to the Garage)
  //   2 Fuel, only when the match cannot answer it (partial or no TFI)
  //   3 Exhaust
  // Answers persist in sessionStorage bgv2_finder, so Back and a reload restore
  // them. /pages/tuning?fit=&years= (the PDP no-tuner note) matches on the
  // pipe's fit tag and starts at step 2, or the result on a full match.
  var F = S.f || {};
  var FKEY = 'bgv2_finder';
  var FUEL = ['efi', 'carb', 'unsure'], EXH = ['installed', 'buying', 'tune'];
  function fGet() { try { return JSON.parse(sessionStorage.getItem(FKEY) || 'null'); } catch (e) { return null; } }
  function fSet(st) { try { if (st) sessionStorage.setItem(FKEY, JSON.stringify(st)); else sessionStorage.removeItem(FKEY); } catch (e) { /* private mode */ } }
  var vocabP = null;
  function vocab() {
    if (!vocabP) vocabP = (CFG.vocabUrl ? fetch(CFG.vocabUrl).then(function (r) { return r.json(); }) : Promise.resolve(null)).catch(function () { return null; });
    return vocabP;
  }
  function fitsVehicle(row, v) {
    if (!window.BGE || !window.BGE.checkFitment) return 'no_fit';
    return window.BGE.checkFitment(window.BGE.parseTags(row.tags), v);
  }
  function matchVehicle(v) {
    var full = null, partial = null;
    TFI.forEach(function (r) {
      if (!hasModel(r)) return;
      var st = fitsVehicle(r, v);
      if (st === 'fits' && !full) full = r;
      else if (st === 'wrong_year' && !partial) partial = r;
    });
    return { kind: full ? 'full' : (partial ? 'partial' : 'none'), row: full || partial };
  }
  function fitMachine(fit) {
    return String(fit || '').replace(/^fit_/, '').split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  function rowByHandle(h) { for (var i = 0; i < TFI.length; i++) if (TFI[i].h === h) return TFI[i]; return null; }
  function steps(st) { return st.kind === 'full' ? 2 : 3; }
  function stepNo(st) { return st.step === 'fuel' ? 2 : (st.step === 'exhaust' ? steps(st) : 1); }
  function fTokens(st) {
    return { year: st.year || '', model: st.model || '', machine: st.machine || '', years: st.yearsText || '', phone: S.phone };
  }

  function fHead(st) {
    var n = stepNo(st), total = st.step === 'machine' ? 3 : steps(st);
    var bar = '';
    for (var i = 1; i <= total; i++) bar += '<span' + (i <= n ? ' class="on"' : '') + '></span>';
    return '<div class="bgv2-tfinder__top"><span class="bgv2-tfinder__count">' + fill(F.step, { n: n, total: total }) + '</span></div>' +
      '<div class="bgv2-tfinder__bar" aria-hidden="true">' + bar + '</div>';
  }
  function nav(st, label) {
    return '<div class="bgv2-tfinder__nav">' +
      (st.step !== 'machine' ? '<button type="button" class="bgv2-textlink" data-f-back>' + esc(F.back) + '</button>' : '') +
      '<button type="submit" class="bgv2-btn bgv2-btn--primary">' + esc(label) + '</button></div>';
  }
  function select(id, label, opts, val, disabled) {
    return '<div class="bgv2-tfinder__field"><label for="bgv2-f-' + id + '">' + esc(label) + '</label>' +
      '<select id="bgv2-f-' + id + '" name="' + id + '"' + (disabled ? ' disabled' : '') + ' aria-describedby="bgv2-f-' + id + '-err">' +
      '<option value="">' + esc(label) + '</option>' +
      opts.map(function (o) { return '<option value="' + esc(o) + '"' + (String(o) === String(val) ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') +
      '</select><p class="bgv2-tfinder__err" id="bgv2-f-' + id + '-err" role="alert" hidden></p></div>';
  }
  function choices(name, labels, values, val) {
    return list(labels).map(function (l, i) {
      var v = values[i] || ('o' + i);
      return '<label class="bgv2-tfinder__choice"><input type="radio" name="' + name + '" value="' + v + '"' + (val === v ? ' checked' : '') + '><span>' + esc(l) + '</span></label>';
    }).join('') + '<p class="bgv2-tfinder__err" role="alert" hidden></p>';
  }

  function fRender(st, focus) {
    fSet(st);
    card.classList.remove('bgv2-tfi--quiet');
    if (st.step === 'result') return fResult(st, focus);
    if (st.step === 'machine') {
      return vocab().then(function (V) {
        V = V || { years: [], makes: [], models_by_make: {} };
        var y = parseInt(st.year, 10);
        var inYear = function (m) { return !y || (m.year_start <= y && y <= m.year_end); };
        var makes = V.makes.filter(function (mk) { return (V.models_by_make[mk] || []).some(inYear); });
        var models = st.make ? (V.models_by_make[st.make] || []).filter(inYear).map(function (m) { return m.name; }).sort() : [];
        card.innerHTML = '<form class="bgv2-tfinder" data-f-step="machine" novalidate>' + fHead(st) +
          '<fieldset><legend class="bgv2-tfinder__q" tabindex="-1">' + esc(F.q1) + '</legend>' +
          select('year', 'Year', V.years.slice().reverse(), st.year) +
          select('make', 'Make', makes, st.make) +
          select('model', 'Model', models, st.model, !st.make) +
          '</fieldset>' + nav(st, F.next) + '<p class="bgv2-tfinder__note">' + esc(F.q1_help) + '</p></form>';
        if (focus) qs('legend', card).focus();
      });
    }
    var isFuel = st.step === 'fuel';
    card.innerHTML = '<form class="bgv2-tfinder" data-f-step="' + st.step + '" novalidate>' + fHead(st) +
      '<fieldset><legend class="bgv2-tfinder__q" tabindex="-1">' + esc(isFuel ? F.q2 : F.q3) + '</legend>' +
      (isFuel ? choices('fuel', F.q2_opts, FUEL, st.fuel) : choices('exhaust', F.q3_opts, EXH, st.exhaust)) +
      '</fieldset>' +
      (isFuel && st.kind === 'partial' && F.q2_note ? '<p class="bgv2-tfinder__note">' + fill(F.q2_note, fTokens(st)) + '</p>' : '') +
      nav(st, isFuel ? F.next : F.show) + '</form>';
    if (focus) qs('legend', card).focus();
    return Promise.resolve();
  }

  function fResult(st, focus) {
    var t = fTokens(st), row = rowByHandle(st.row), html = '', quiet = false;
    var callBtn = '<a class="bgv2-btn bgv2-btn--primary bgv2-btn--block" href="' + tel() + '">' + fill(S.call, t) + '</a>';
    var restart = '<button type="button" class="bgv2-textlink bgv2-tfinder__restart" data-f-restart>' + esc(F.restart) + '</button>';
    if (st.kind === 'full' && row) {
      var line = st.exhaust === 'installed' ? F.lean : (st.exhaust === 'buying' ? F.buying : '');
      html = '<p class="bgv2-tfi__eyebrow">' + ICO.tick + '<span>' + fill(S.fits, t) + '</span></p>' +
        '<h3 class="bgv2-tfi__h" tabindex="-1">' + fill(F.full_h, t) + '</h3>' +
        (line ? '<p class="bgv2-tfi__line">' + fill(line, t) + '</p>' : '') + itemHtml(row, st.machine) +
        '<div class="bgv2-tfi__actions"><button type="button" class="bgv2-btn bgv2-btn--primary bgv2-btn--block" data-hero-add="tfi" data-src="finder" data-variant="' + row.v + '" data-pn="' + esc(row.pn) + '">' + fill(S.add, { price: money(row.p) }) + '</button>' +
        (st.exhaust === 'buying' ? '<a class="bgv2-textlink" href="#" data-hero-shop>' + fill(S.shop, t) + '</a>' : '') + '</div>' +
        '<p class="bgv2-tfi__fine">' + esc(F.warranty) + ' ' + esc(S.ca) + '</p>';
    } else if (st.kind === 'partial' && row && st.fuel !== 'carb') {
      quiet = true;
      html = '<p class="bgv2-tfi__eyebrow is-partial">' + ICO.warn + '<span>' + fill(F.partial_fit, t) + '</span></p>' +
        '<h3 class="bgv2-tfi__h" tabindex="-1">' + fill(S.bH, t) + '</h3>' + itemHtml(row, st.machine) +
        '<div class="bgv2-tfi__actions"><button type="button" class="bgv2-btn bgv2-btn--secondary bgv2-btn--block" data-hero-add="tfi" data-src="finder" data-variant="' + row.v + '" data-pn="' + esc(row.pn) + '">' + fill(/^\d{4}$/.test(String(t.years)) ? S.bAdd : (S.bAddRange || 'Mine is a {years} model. Add it'), t) + '</button>' +
        '<a class="bgv2-textlink" href="' + tel() + '">' + fill(F.partial_call, t) + '</a></div>' +
        '<p class="bgv2-tfi__fine">' + esc(S.ca) + '</p>';
    } else if (st.fuel === 'carb') {
      quiet = true;
      var onGuide = location.pathname.replace(/\/$/, '') === String(S.tuningUrl || '').replace(/\/$/, '');
      html = '<h3 class="bgv2-tfi__h" tabindex="-1">' + fill(F.carb_h, t) + '</h3><p class="bgv2-tfi__line">' + fill(F.carb_line, t) + '</p>' +
        '<div class="bgv2-tfi__actions">' + callBtn + '</div><p class="bgv2-tfi__fine">' + esc(S.hours) +
        (onGuide ? '' : ' <a href="' + esc(S.tuningUrl) + '">' + esc(F.guide) + '</a>') + '</p>';
    } else {
      quiet = true;
      html = '<h3 class="bgv2-tfi__h" tabindex="-1">' + fill(F.none_h, t) + '</h3><p class="bgv2-tfi__line">' + fill(F.none_line, t) + '</p>' +
        '<div class="bgv2-tfi__actions">' + callBtn + '</div><p class="bgv2-tfi__fine">' + esc(S.hours) + '</p>';
    }
    card.innerHTML = '<div class="bgv2-tfinder__res">' + restart + html + '</div>';
    card.classList.toggle('bgv2-tfi--quiet', quiet);
    if (st.make) resolveShop({ year: st.year, make: st.make, model: st.model });
    if (focus) { var h = qs('.bgv2-tfi__h', card); if (h) h.focus(); }
    if (!st.tracked) {
      st.tracked = true; fSet(st);
      track('tfi_finder_result', { match: st.kind, fuel: st.fuel || 'skipped', exhaust: st.exhaust || '' });
    }
    return Promise.resolve();
  }

  function fOpen(st, focus) {
    finderOn = true;
    if (current !== 'E') resetE();
    current = 'E';
    hero.setAttribute('data-state', 'finder');
    return fRender(st, focus);
  }
  function fError(form, el, msg) {
    var err = el.tagName === 'SELECT' ? qs('#' + el.id + '-err', form) : qs('.bgv2-tfinder__err', form);
    if (err) { err.textContent = msg; err.hidden = false; }
    el.focus();
  }

  // Entry: State E "Find my box".
  hero.addEventListener('click', function (e) {
    if (e.target.closest('[data-hero-find]')) { fOpen({ step: 'machine' }, true); return; }
    if (e.target.closest('[data-f-restart]')) { fOpen({ step: 'machine' }, true); return; }
    if (e.target.closest('[data-f-back]')) {
      var st = fGet() || { step: 'machine' };
      if (st.step === 'exhaust' && st.kind !== 'full') st.step = 'fuel';
      else if (st.fromLink && (st.step === 'fuel' || st.step === 'exhaust')) { fSet(null); finderOn = false; resetE(); return; }
      else st.step = 'machine';
      fRender(st, true);
    }
  });
  // Step 1 selects: Make filters by Year, Model by Make and Year.
  hero.addEventListener('change', function (e) {
    var sel = e.target.closest('.bgv2-tfinder[data-f-step="machine"] select');
    if (!sel) return;
    var st = fGet() || { step: 'machine' };
    st[sel.name] = sel.value;
    if (sel.name !== 'model') st.model = '';
    if (sel.name === 'year') st.make = st.make || '';
    fRender(st, false).then(function () { var again = qs('#bgv2-f-' + sel.name, card); if (again) again.focus(); });
  });
  hero.addEventListener('submit', function (e) {
    var form = e.target.closest('.bgv2-tfinder');
    if (!form) return;
    e.preventDefault();
    var st = fGet() || { step: 'machine' };
    var step = form.getAttribute('data-f-step');
    if (step === 'machine') {
      var names = { year: 'year', make: 'make', model: 'model' };
      for (var k in names) {
        var el = form.elements[k];
        if (!el.value) { fError(form, el, fill(F.err, { field: names[k] })); return; }
        st[k] = el.value;
      }
      var v = { year: parseInt(st.year, 10), make: st.make, model: st.model };
      if (window.BGE && window.BGE.Garage) window.BGE.Garage.add(v.year, v.make, v.model);
      var m = matchVehicle(v);
      st.kind = m.kind; st.row = m.row ? m.row.h : ''; st.yearsText = m.row ? yearsText(m.row.y) : '';
      st.machine = [st.year, st.make, st.model].join(' '); st.fit = ''; st.fromLink = false;
      st.step = m.kind === 'full' ? 'exhaust' : 'fuel';
      track('tfi_finder_step', { step: 1, answer: st.machine });
    } else {
      var name = step === 'fuel' ? 'fuel' : 'exhaust';
      var checked = qs('input[name="' + name + '"]:checked', form);
      if (!checked) { fError(form, qs('input[name="' + name + '"]', form), fill(F.err, { field: 'answer' })); return; }
      st[name] = checked.value;
      track('tfi_finder_step', { step: stepNo(st), answer: checked.value });
      st.step = step === 'fuel' ? 'exhaust' : 'result';
    }
    st.tracked = false;
    fRender(st, true);
  });
  // Selected choice: 2px border plus the checked radio (never colour alone).
  hero.addEventListener('change', function (e) {
    var r = e.target.closest('.bgv2-tfinder__choice input');
    if (!r) return;
    Array.prototype.forEach.call(r.form.querySelectorAll('.bgv2-tfinder__choice'), function (l) { l.classList.toggle('is-on', l.contains(r)); });
  });

  // Deep link from the PDP no-tuner note: /pages/tuning?fit=<fit tag>&years=<year tag>
  function fromLink() {
    var q = new URLSearchParams(location.search), fit = q.get('fit');
    if (!fit || !/^fit_[a-z0-9-]+$/.test(fit)) return null;
    var years = (q.get('years') || '').replace(/[^0-9-]/g, '');
    var pm = matchPipe({ fit: fit, y: years });
    var machine = fitMachine(fit);
    var st = { fromLink: true, fit: fit, machine: machine, model: modelFromMachine(machine), year: '', yearsText: '' };
    if (!pm) { st.kind = 'none'; st.row = ''; }
    else {
      st.kind = pm.full ? 'full' : 'partial';
      st.row = pm.row.h;
      st.yearsText = pm.rows.map(function (r) { return yearsText(r.y); }).filter(Boolean).join(' and ');
    }
    st.step = st.kind === 'full' ? 'result' : 'fuel';
    if (st.kind === 'full') st.exhaust = 'buying';
    return st;
  }

  // Jump link: anchor the first heading of the page body.
  (function () {
    var rte = document.querySelector('.page .rte');
    var first = rte && rte.querySelector('h2, h3');
    if (first) { if (!first.id) first.id = 'bgv2-tune-how'; }
    var id = first ? first.id : '';
    hero.addEventListener('click', function (e) {
      var a = e.target.closest('[data-hero-jump]');
      if (!a) return;
      if (!id) { e.preventDefault(); return; }
      a.setAttribute('href', '#' + id);
    });
    if (!first) { var j = qs('.bgv2-tune-hero__jump', hero); if (j && j.querySelector('[data-hero-jump]')) j.hidden = true; jumpHtml = ''; }
  })();

  // Boot once the Garage is there. bge-garage.js is deferred and comes after this file in the document, so on a slow
  // phone it runs only just before DOMContentLoaded (about 26 s on Slow 4G): the old 5 s poll gave up first and the
  // machine's box never showed (FL5-12). Try now, then at DOMContentLoaded, when every deferred script has run; only a
  // Garage still missing then gets the plain State E. The section's inline check may hold the hero (bgv2-tune-pending)
  // or keep its State A height (bgv2-tune-wait) until this first render, so the swap moves nothing.
  function settled() { document.documentElement.classList.remove('bgv2-tune-pending', 'bgv2-tune-wait'); }
  var booted = false;
  function boot(final) {
    if (booted) return;
    var G = window.BGE && window.BGE.Garage;
    if (G && typeof G.active === 'function') {
      booted = true;
      var link = fromLink(), saved = fGet();
      if (link) fOpen(link, false);
      else if (saved && saved.step) fOpen(saved, false);
      else render(G);
      settled();
      hero.setAttribute('data-hero-booted', '1');
      if (typeof G.onChange === 'function') G.onChange(function () { render(G); });
      window.BGV2_TUNE = { render: function () { render(G); }, match: matchGarage, matchPipe: matchPipe, rows: TFI };
      return;
    }
    if (final) { booted = true; render(null); settled(); }
  }
  boot(false);
  if (document.readyState === 'complete') boot(true);
  else document.addEventListener('DOMContentLoaded', function () { boot(true); });
})();
